import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const css = {
  mainBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '100vh',
    justifyContent: 'center',
  },
  text: { fontWeight: '800', fontSize: '4rem', mb: 1 },
};

/**
 * Return a not fount message and a btn to return to the main page
 * @returns {JSX.Element}
 */

const CountryNotFound = () => {
  return (
    <Box sx={css.mainBox}>
      <Typography variant="h1" sx={css.text}>
        404
      </Typography>
      <Typography variant="h2">Página no encontrada</Typography>
    </Box>
  );
};

export default CountryNotFound;
